module.exports = __webpack_public_path__ + "img/76296.1398411d.svg";